import DefaultStep from './DefaultStep.component';

export default DefaultStep;